import { Component, EventEmitter, Input, Output } from '@angular/core';

import { map, Observable } from 'rxjs';

import { ApiThema, SubjectCategoriesClient } from 'content-manager/src/app/core/open-api/content-manager-api-client';

export interface IThemaGroup {
    parent: ApiThema;
    children: ApiThema[];
}

@Component({
    selector: 'cm-thema-picker',
    templateUrl: './thema-picker.component.html',
    standalone: false
})
export class ThemaPickerComponent {

    @Input() public selected: string[] = [];

    @Input() public disabled = false;

    @Input() public hintText: string | null = null;

    @Output() public readonly selectedChange = new EventEmitter<string[]>();

    public readonly themaGroups$: Observable<IThemaGroup[]>;

    constructor(subjectCategoriesClient: SubjectCategoriesClient) {
        this.themaGroups$ = subjectCategoriesClient.getThemas().pipe(
            map(themas => this._groupThemas(themas)));
    }

    public onSelectedChange(value: string[]): void {
        this.selected = value;
        this.selectedChange.emit(value);
    }

    private _groupThemas(themas: ApiThema[]): IThemaGroup[] {
        const parentThemas = themas.filter(t => !t.parentCode);
        const childThemas = themas.filter(t => t.parentCode);

        return parentThemas.map(parent => ({
            parent,
            children: childThemas.filter(child => child.parentCode === parent.code)
        }));
    }
}
